import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { Post, Discard } from '../../../Constant';
import { Btn, H5, H6, Spinner } from '../../../AbstractElements';
import CategoryProgramForm from './CategoryProgramForm';
import { useSelector, useDispatch } from 'react-redux';
import { submitCategoryProgram } from '../../../Features/Learning/CategoryProgram/Utils/CategoryProgramUtils';
import { resetState } from '../../../Features/Learning/CategoryProgram/addCategoryProgramSlice';
import Swal from 'sweetalert2';

const CategoryProgramPost = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.addCategoryProgram);
  const startUpload = useSelector((state) => state.addCategoryProgram.isLoading);
  const isUpdate = useSelector((state) => state.addCategoryProgram.isUpdate);

  const handleSuccess = () => {
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/category-program`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorMessage = '';
    if (!data.name) {
      errorMessage = 'Nama Kategori tidak boleh kosong.';
    } else if (!data.slug) {
      errorMessage = 'Nama Slug Kategori tidak boleh kosong.';
    } else if (data.children.length > 0) {
      for (let i = 0; i < data.children.length; i++) {
        if (!data.children[i].name) {
          errorMessage = 'Sub Kategori ada yang belum diisi.';
        } else if (!data.children[i].slug) {
          errorMessage = 'Sub Slug Kategori ada yang belum diisi.';
        }
      }
    }

    if (data.name && data.slug && data.children.length > 0 && data.children.every((cat) => cat.name && cat.slug)) {
      dispatch(submitCategoryProgram({ ...data, successCallback: handleSuccess }));
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Terjadi kesalahan!',
        text: errorMessage,
      });
    }
  };

  const handleDiscard = (e) => {
    e.preventDefault();
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/category-program`);
  };

  return (
    <Fragment>
      <Container fluid className="category-program">
        <Row>
          <Col sm="12">
            {startUpload ? (
              <Card className="category-program__state">
                <CardBody className="text-center py-5">
                  <div className="loader-box justify-content-center">
                    <Spinner attrSpinner={{ className: 'loader-30' }} />
                  </div>
                  <H6 attrH6={{ className: 'sub-title mb-0 mt-2' }}>Sedang proses unggah...</H6>
                </CardBody>
              </Card>
            ) : (
              <Card className="category-program-form__card">
                <CardHeader className="category-program-form__header pb-3">
                  <H5>{isUpdate ? 'Perbarui Category Program' : 'Category Program Baru'}</H5>
                </CardHeader>
                <CardBody className="add-post pt-3">
                  <CategoryProgramForm />
                  <div className="category-program-form__footer btn-showcase text-end">
                    <Btn attrBtn={{ color: 'light', type: 'reset', onClick: handleDiscard }}>{Discard}</Btn>
                    <Btn attrBtn={{ color: 'primary', type: 'submit', onClick: handleSubmit }}>{Post}</Btn>
                  </div>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CategoryProgramPost;
